export const getFocalPointStyle = (focalPointX, focalPointY) => {
  if (focalPointX && focalPointY) {
    return `${focalPointX * 100}% ${focalPointY * 100}%`;
  }
  return 'none';
};
